export const calculateHeight = (header = true, breadcrumbs = true, toolbar = true, base= 0, misc = 0, theme = false) => {
    const toolbarHeight = toolbar ? "56px" : "0px"
    const breadcrumbsHeight = breadcrumbs ? "42px" : "0px"
    const headerHeight = header ? "40px" : "0px"
    const miscHeight = `${misc}px`
    const baseHeight = base ? `${base}px` : "100%"
    const spacing = theme ? theme.spacing(1) : 8

    return `calc( ${baseHeight} - ${headerHeight} - ${breadcrumbsHeight} - ${toolbarHeight} - ${miscHeight} - ${spacing}px )`
}